<template>
	<section>
		<section class="task-wrapper">
			<div class="task-item" v-for="item in list"  @click="toDetail(item.id)">
				<div class="title" style="-webkit-box-orient: vertical;">{{item.title}}</div>
				<div class="type">需求类型：{{item.typeName}}</div>
				<div class="detail" style="-webkit-box-orient: vertical;">{{item.details}}</div>
				<div class="price"><span class="priceNum">{{item.amount}}元</span></div>
				<div class="status">
					<el-tag v-if="item.status == 0" size="small" effect="plain">未审核</el-tag>
					<el-tag v-else-if="item.status == 1" size="small" effect="plain">已审核</el-tag>
					<el-tag v-else-if="item.status == 2" size="small" effect="plain">竞标中</el-tag>
					<el-tag v-else-if="item.status == 3" size="small" effect="plain">选标中</el-tag>
					<el-tag v-else-if="item.status == 4" size="small" style="border-color: #51C384;color: #51C384;" effect="plain">进行中</el-tag>
					<el-tag v-else-if="item.status == 5" size="small" style="border-color: #DF3535;color: #DF3535;" effect="plain">已完成</el-tag>
					<span class="publishDate">{{item.createDate}}发布</span>
				</div>
			</div>
			
		</section>
		<el-pagination class="page"
			:hide-on-single-page="true"
			:page-size="9"
		    layout="prev, pager, next"
			@current-change="handleCurrentChange"
		    :total="total">
		  </el-pagination>
	</section>
</template>

<script>
import { getTaskList,getType } from '@/api/crowd/index'
export default {
    data() {
      return {
		page:1,
		total: 0,
        list:[]
      };
    },
    methods: {
	  handleCurrentChange(val){
		this.page = val
	  	this.getDatalist()
	  },
	  async getDatalist(){
	  	const res = await getTaskList({page:this.page,limit:9})
	  	if (res.code === 0) {
			res.data.list.forEach((item)=>{
				item.createDate = new Date(item.createDate).toLocaleDateString().replaceAll('/','-')
				this.typelist.forEach((val)=>{
					if(val.dictValue == item.type){
						item.typeName = val.dictLabel
					}
				})
			})
	  		this.list = res.data.list
	  		this.total = res.data.total
	  	} else {
	  	  this.$message.error(res.msg)
	  	}
	  },
	  async getTypelist(){
	  	const res = await getType()
	  	if (res.code === 0) {
	  		this.typelist = res.data[0].dataList
			this.getDatalist()
	  	} else {
	  	  this.$message.error(res.msg)
	  	}
	  },
	  toDetail(id){
		  this.$router.push({name:'demand-detail',params:{id:id}})
	  }
    },
	mounted(){
		this.getTypelist()
	}
}
</script>

<style lang="scss" scoped>
.task-wrapper{
	display: flex;
	.task-item{
		flex: 0 0 32%;
		margin-right: 1%;
		background-color: #fff;
		box-shadow:  0 0 15px rgba(0,0,0,.05);
		font-size: 14px;
		color: #6D6D6D;
		padding: 20px 0;
		box-sizing: border-box;
		border-radius: 8px;
		cursor: pointer;
		&>div{
			margin-top: 8px;
			padding:  0 30px;
		}
		.title{
			color: #333333;
			font-size: 18px;
			font-weight: 800;
			margin: 0;
			overflow: hidden;
			display: -webkit-box;
			-webkit-line-clamp: 1;
			-webkit-box-orient: vertical;
			text-overflow: ellipsis;
		}
		.detail{
			overflow: hidden;
			display: -webkit-box;
			-webkit-line-clamp: 3;
			-webkit-box-orient: vertical;
			text-overflow: ellipsis;
			white-space: normal;
		}
		.price{
			.priceNum{
				font-size: 20px;
				color: #FF842E;
				font-weight: 800;
			}
		}
		.status {
			border-top: 1px dashed #D4D4D4;
			padding-top: 10px;
			margin-top: 20px;
			.publishDate{
				float: right;
				margin-top: 3px;
			}
		}
	}
}
</style>